import { EmailRedirectionComponent } from './settings/email-redirection/email-redirection.component';
import { FirstloginComponent } from './firstlogin/firstlogin.component';
import { EmailIntegrationComponent } from './settings/email-integration/email-integration.component';
import { TeaminviteComponent } from './teaminvite/teaminvite.component';
import { PricingComponent } from './accounts/pricing/pricing.component';
import { SubscriptionUsageComponent } from './accounts/subscription-usage/subscription-usage.component';
import { IframeSearchtoolboxComponent } from './SearchBox/iframe-searchtoolbox/iframe-searchtoolbox.component';
import { ProfileDetailsComponent } from './user/profile-details/profile-details.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SettingsComponent } from './settings/settings.component';
import { SignupComponent } from './signup/signup.component';
import { CandidateListComponent } from './candidate/candidate-list/candidate-list.component';
import { TalentpoolListComponent } from './talentpool/talentpool-list/talentpool-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmartsearchComponent } from './SearchBox/smartsearch/smartsearch.component';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { EmailTemplateComponent } from './settings/email-template/email-template.component';
import { CallLogSettingsComponent } from './settings/call-log-settings/call-log-settings.component';
import { SearchtoolboxV2Component } from './SearchBox/searchtoolbox-v2/searchtoolbox-v2.component';
import { ExpiryComponent } from "./expirylink/expirylink.component";
import { SearchtoolboxV3Component } from './SearchBox/searchtoolbox-v3/searchtoolbox-v3.component';
import { CompanydirectoryComponent } from './companypages/companydirectory/industrylist/companydirectory.component';
import { CompanyinfoComponent } from './companypages/companyinfo/companyinfo.component';
import { CompanylistComponent } from './companypages/companydirectory/companylist/companylist.component';
import { PersonSearchComponent } from './person-search/person-search.component';
import { PersonSearchListingComponent } from './person-search-listing/person-search-listing.component';
import { TalnepoolCandidateTabsComponent } from './talnepool-candidate-tabs/talnepool-candidate-tabs.component';
import { TalentpoolDetailsComponent } from './talentpool/talentpool-details/talentpool-details.component';
import { NewCompnayPageComponent } from './companypages/new-compnay-page/new-compnay-page.component';
import { CompanyListComponent } from './companypages/company-list/company-list.component';
import { DocumentPreviewComponent } from './candidate/candidate-slider/document-preview/document-preview.component';
import { CompanyDetailsComponent } from './companypages/company-details/company-details.component';
import { DiversityTabComponent } from './companypages/diversity-tab/diversity-tab.component';
import { EducationTabComponent } from './companypages/education-tab/education-tab.component';
import { SkillsTabComponent } from './companypages/skills-tab/skills-tab.component';
import { TalentmovementTabComponent } from './companypages/talentmovement-tab/talentmovement-tab.component';
import { TitlesTabComponent } from './companypages/titles-tab/titles-tab.component';
import { OverviewTabComponent } from './companypages/overview-tab/overview-tab.component';
import { AttrtionTabComponent } from './companypages/attrtion-tab/attrtion-tab.component';
import { LocationTabComponent } from './companypages/location-tab/location-tab.component';
import { CompprofileTabComponent } from './companypages/compprofile-tab/compprofile-tab.component';
import { ReportsComponent } from './reports/reports.component';
import { PersonalReportsComponent } from './reports/personal-reports/personal-reports.component';
import { TeamMembersReportsComponent } from './reports/team-members-reports/team-members-reports.component';
import { TalentpoolInsightsComponent } from './talentpool-insights/talentpool-insights.component';
import { ReportDetailsComponent } from './talentpool-insights/report-details/report-details.component';
import { ReportOverviewTabComponent } from './talentpool-insights/report-overview-tab/report-overview-tab.component';
import { ReportLocationTabComponent } from './talentpool-insights/report-location-tab/report-location-tab.component';
import { ReportEducationTabComponent } from './talentpool-insights/report-education-tab/report-education-tab.component';

import { ReportDiversityComponent } from './talentpool-insights/report-diversity/report-diversity.component';

import { ReportSkillsComponent } from './talentpool-insights/report-skills/report-skills.component';
import { ReportIndustriesComponent } from './talentpool-insights/report-industries/report-industries.component';
import { ReportCompanyComponent } from './talentpool-insights/report-company/report-company.component';
import { ReportProfilesComponent } from './talentpool-insights/report-profiles/report-profiles.component';
import { ReportTitlesComponent } from './talentpool-insights/report-titles/report-titles.component';
import { SharedTalentpoolsListingComponent } from './talentpool/shared-talentpools-listing/shared-talentpools-listing.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path : 'smartsearch' , component : SmartsearchComponent},
  // { path : 'candidate-list' , component : CandidateListComponent},
  { path:  'candidate-list/talentpool/:id', component: CandidateListComponent},
  { path:  'createcandidate', component: CreateCandidateComponent},
  { path:  'signup', component: SignupComponent},
  { path:  'login', component: SignupComponent},
  { path:  'unsubscribe', component: UnsubscribeComponent},
  { path:  'forgetpassword', component: ResetpasswordComponent},
  { path:  'resetpassword', component: ResetpasswordComponent},
  { path:  'settings', component: SettingsComponent},
  { path:  'settings/emailtemplate', component: EmailTemplateComponent},
  { path:  'settings/calllog', component: CallLogSettingsComponent},
  { path:  'feedback', component: FeedbackComponent},
  { path:  'profiledetails', component: ProfileDetailsComponent},
  { path:  'searchtoolbox-v2', component: SearchtoolboxV3Component},
  { path:  'iframe-searchtoolbox', component: IframeSearchtoolboxComponent},
  { path:  'subscription/usage', component: SubscriptionUsageComponent},
  { path:  'subscription/history', component: SubscriptionUsageComponent},
  { path:  'subscription/pricing', component: PricingComponent},
  { path:  'teaminvite', component: TeaminviteComponent},
  { path:  'firstlogin', component: FirstloginComponent},
  { path:  'settings/email-integration', component: EmailIntegrationComponent},
  { path: 'expiry', component: ExpiryComponent},
  { path: 'email_redirection', component: EmailRedirectionComponent},
  { path: 'company-directory/industries', component: CompanydirectoryComponent},
  { path: 'company-directory/:cname/:cid', component: CompanyinfoComponent},
  { path: 'company-directory/:industry', component: CompanylistComponent},
  {path: 'person/search', component: PersonSearchComponent},
  {path: 'person/search/listing', component: PersonSearchListingComponent},
  {path: 'talentpool/details/:id', component: TalentpoolDetailsComponent},
  { path: 'companypage', component: NewCompnayPageComponent},
  { path: 'company-list', component: CompanyListComponent},
  { path: 'reports', component: ReportsComponent},
  { path: 'talentpool-insights', component: TalentpoolInsightsComponent},
  { path: 'report-details', component: ReportDetailsComponent, 
      children:[
        { path: '', redirectTo: "report-overview", pathMatch: "full"},
        { path: 'report-overview', component: ReportOverviewTabComponent },
        { path: 'report-location', component: ReportLocationTabComponent},
        { path: 'report-education', component: ReportEducationTabComponent},
        { path: 'report-diversity', component: ReportDiversityComponent},
        { path: 'report-skills', component: ReportSkillsComponent},
        { path: 'report-industries', component: ReportIndustriesComponent},
        { path: 'report-company', component: ReportCompanyComponent},
        { path: 'report-profiles', component: ReportProfilesComponent},
        { path: 'report-titles', component: ReportTitlesComponent},


      ]},

  { path: 'company-details/:company-id', component: CompanyDetailsComponent,
    children: [
      { path: "", redirectTo: "overview", pathMatch: "full"},
      { path: 'overview', component: OverviewTabComponent },
      { path: 'location', component: LocationTabComponent},
      { path: 'attrition', component: AttrtionTabComponent},
      { path: 'education', component: EducationTabComponent},
      { path: 'skills', component: SkillsTabComponent},
      { path: 'titles', component: TitlesTabComponent},
      { path: 'talent-movement', component: TalentmovementTabComponent},
      { path: 'profile', component: CompprofileTabComponent},
      { path: 'diversity', component: DiversityTabComponent}
    ]
   },

  {path: 'document-preview/:candidateid/:docid', component: DocumentPreviewComponent},
  {
    path: 'talent',
    component: TalnepoolCandidateTabsComponent,
    children: [
      { path: "", redirectTo: "talentpool", pathMatch: "full"},
      { path : 'candidate-list' , component : CandidateListComponent},
      { path : 'talentpool' , component : TalentpoolListComponent},
      { path : 'shared-talentpool', component: SharedTalentpoolsListingComponent }

    ]
  },
  { path: 'reports', component: ReportsComponent,
    children: [
      { path: "", redirectTo: "personal-reports", pathMatch: "prefix"},
      { path: 'personal-reports',  component:PersonalReportsComponent},
      { path: 'team-members',  component:TeamMembersReportsComponent}
    ]
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
